import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_ds_find_vendorlotsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { searchProperties: { vendorLotId?: number, vendorLotCode?: string, materialId?: number }[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, MaterialId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.searchProperties)) {
      missingRequiredInParams.push('\'searchProperties\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { searchProperties: { vendorLotId?: number, vendorLotCode?: string, materialId?: number }[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, MaterialId?: number }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.searchProperties)) {
      missingRequiredInParams.push('\'searchProperties\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { searchProperties: { vendorLotId?: number, vendorLotCode?: string, materialId?: number }[], $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, MaterialId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.searchProperties)) {
      missingRequiredInParams.push('\'searchProperties\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      searchProperties: { vendorLotId?: number, vendorLotCode?: string, materialId?: number }[]    }) {
        if(isNil(inParams.searchProperties)) {
          return true; 
        }
      return false;
    }
}
